import { Close, DeleteOutline } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import CommentIcon from "../../icons/CommentIcon";
import CommentEditIcon from "../../icons/CommentEditIcon";

function Modal2({
    open = false,
    hideActions = false,
    onClose = null,
    header = null,
    children,
    onModalSubmit = null,
    onDelete = null,
    showDeleteButton = false,
    SubmitButtonText = "Submit",
    showHeadingIcon = false,
    hideHeading = false,
    headingIcon = null,
    width = 599,
    contentSx = {},
    type = "create",
    containerSx={},
    ...otherProps
}) {
    return (
        <Modal open={open} onClose={onClose} {...otherProps}>
            <Box
                // width={width}
                sx={(theme) => ({
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",

                    bgcolor: "background.paper",
                    padding: "1.5rem",

                    borderRadius: "12px",
                    background: "#FFF",

                    /* Shadow/2xl */
                    boxShadow: "0px 24px 48px -12px rgba(16, 24, 40, 0.18)",

                    width:{
                        xs:"100%",
                        sm:width
                    },
                    // height:{
                    //     xs:"unset",
                    //     sm:'unset'
                    // },
                    maxWidth: {
                        xs: "90%",
                        sm: 'unset',
                    },
                    maxHeight: {
                        xs: "95%",
                        // sm: "90%",
                    },
                    overflow: {
                        xs: "auto",
                        // sm:"unset"
                    },

                    ...containerSx,
                })}
            >
                <Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                marginRight: "0.5rem",
                            }}
                        >
                            {headingIcon ||
                                (type === "create" ? (
                                    <CommentIcon />
                                ) : (
                                    <CommentEditIcon />
                                ))}
                        </Box>
                        {!hideHeading && <Typography>heading</Typography>}
                    </Box>
                    {true && (
                        <IconButton
                            aria-label='close'
                            onClick={onClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Close />
                        </IconButton>
                    )}
                </Box>

                <Box
                    sx={{

                        height:"calc(100% - 150px)",
                        overflow:{
                            xs:"auto",
                            sm:"unset"

                        },
                        padding:{
                            xs:"0.5rem",
                            sm:"unset"
                        },
                        
                        ...contentSx,
                    }}
                >
                    {children ? children : "Modal Open"}
                </Box>

                {/* buttons UI */}
                <Box
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    marginTop={"1rem"}
                    flexDirection={{
                        xs: "column",
                        sm: "row",
                    }}
                >
                    {showDeleteButton && (
                        <Box
                            flex={1}
                            display={"flex"}
                            justifyContent={"flex-start"}
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "unset",
                                },
                                marginRight:"0.5rem"
                            }}
                        >
                            <Button
                                variant='outlined'
                                sx={{
                                    maxHeight: "40px",
                                    padding: "10px 16px",
                                    width: {
                                        xs: "100%",
                                        sm: "unset",
                                    },
                                }}
                                onClick={onDelete}
                                startIcon={<DeleteOutline />}
                                color='error'
                            >
                                Delete
                            </Button>
                        </Box>
                    )}
                    <Button
                        variant='outlined'
                        sx={{
                            maxHeight: "40px",
                            padding: "10px 16px",
                            marginTop: {
                                xs: "0.5rem",
                                sm: "0",
                            },
                            width: {
                                xs: "100%",
                                sm: "unset",
                            },
                        }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant='contained'
                        sx={{
                            maxHeight: "40px",
                            padding: "10px 16px",
                            marginTop: {
                                xs: "0.5rem",
                                sm: "0",
                            },
                            marginLeft: {
                                xs: "0",
                                sm: "0.5rem",
                            },
                            width: {
                                xs: "100%",
                                sm: "unset",
                            },
                        }}
                        onClick={onModalSubmit}
                    >
                        {SubmitButtonText}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default Modal2;
